import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { SEARCH_OPTION_SECTION } from "../constants";
import { getMediaItemSearchOptions, getVisualBuilderSearchOptions } from "../store/actions";
import { searchOptionsSelector } from "../store/selectors";
import { isRequestAllowed } from "../utils/helper";

export function useSearchOptionsData(props) {
  const { params, section, entities = [] } = props;

  const dispatch = useDispatch();
  const timer = useRef(null);
  const firstRender = useRef(true);

  const { status } = useSelector(searchOptionsSelector(params, section));

  const fetchSearchOptions = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      if (section === SEARCH_OPTION_SECTION.MEDIA_ITEM) {
        dispatch(getMediaItemSearchOptions(params));
      }

      if (section === SEARCH_OPTION_SECTION.VISUAL_BUILDER) {
        dispatch(getVisualBuilderSearchOptions(params));
      }
    }, 300);
  };

  useEffect(() => {
    if (isRequestAllowed(status) || firstRender.current) {
      fetchSearchOptions();
    }
    firstRender.current = false;
  }, [JSON.stringify(params), section]);

  useEffect(() => {
    const listener = () => fetchSearchOptions();

    entities.forEach((entity) => document.addEventListener(entity, listener));
    return () => entities.forEach((entity) => document.removeEventListener(entity, listener));
  }, [params, section]);
}
